export default "__VITE_ASSET__Cut$KsDL__"